<div id="lien">
    <a routerLink="/incidents">Retour à la liste</a>
</div>
<ng-container *ngIf="incident && incident.rg_pannes">
    <div class="wrapper">
        <div class="right">
            <span>Informations</span>
            <div>
                <h2>{{incident.nom_installation}}</h2>
            </div>
            <div>
                <p>{{incident.statut_installation}}</p>
            </div>
            <div>
                <p>Suivi jusqu'au {{incident.suivi_date_fin}} ( depuis le {{ incident.suivi_date_debut }} )</p>
            </div>
            <div>
                <p>Importance : {{ incident.suivi_importance_s}} </p>
            </div>
            <div>
                <button class="btn btn-success">Valider</button>
                <button class="btn btn-primary">Suivi + 1 semaine</button>
                <button class="btn btn-primary">Suivi + 2 semaines</button>
                <button class="btn btn-danger">Arrêter le suivi</button>
            </div>
        </div>
        <div class="left">
            <div>
                <div>
                    <label for="motif">Motif de suivi : </label>
                    <input id="motif" type="text">
                </div>
            </div>
            <div>
                <div>
                    <label for="commentaires">Commentaires : </label>
                    <textarea name="commentaires" id="commentaires" cols="30" rows="5"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="test">
        <div class="wrapper">
            <div class="table-responsive">
                <span>Pannes non-traitées</span>
                <table class="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Panne</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let panneNonTraitee of incident.rg_pannes">
                            <tr>
                                <td>{{ panneNonTraitee.date_panne }}</td>
                                <td>{{ panneNonTraitee.sujet }}</td>
                                <td>Traiter</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="wrapper">
            <div class="table-responsive">
                <span>Rapports d'erreurs non-traités</span>
                <table class="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>En-tête</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="incident.error_reports">
                            <ng-container *ngFor="let rapportNonTraite of incident.error_reports">
                                <tr>
                                    <td>{{ rapportNonTraite.date_report }}</td>
                                    <td>{{ rapportNonTraite.sujet }}</td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="test">
        <div class="wrapper">
            <div class="table-responsive">
                <span>Anomalies</span>
                <table class="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Anomalies</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>OK</td>
                            <td>OK</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="wrapper">
            <div class="table-responsive">
                <span>Messages</span>
                <table class="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>En-tête</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>OK</td>
                            <td>OK</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-container>